import React from "react";
import Container from "../../hoc/Container";
import { tgIcon, insale_psn_pl, insale_psn_in } from "../../../images";

function PlayStationDiscount() {
  return (
    <Container>
      <div className="content-block">
        <div className="head-1">Скоро тут будут лучшие предложения PlayStation</div>
        <div className="mt-2 text-center">
          А пока можете посмотреть скидки здесь:
        </div>
        <div className="discount-grid mt-4">
          <a
            className="discount-card"
            href="https://psprices.com/region-pl/collection/most-wanted-deals?platform=PS4%2CPS5"
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="discount-image"
              src={insale_psn_pl}
              alt="Скидки PSN Польша"
            />
            <div className="discount-overlay">Посмотреть скидки PSN Poland</div>
          </a>
          <a
            className="discount-card"
            href="https://psprices.com/region-in/collection/most-wanted-deals?platform=PS5%2CPS4"
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="discount-image"
              src={insale_psn_in}
              alt="Скидки PSN Индия"
            />
            <div className="discount-overlay">Посмотреть скидки PSN India</div>
          </a>
        </div>
        <div className="mt-4 flex flex-col items-center gap-2 sm:flex-row sm:flex-wrap sm:justify-center lg:flex-nowrap">
          <a
            href="https://t.me/trendy_psn_bot?start=ref-001"
            className="mb-3 flex w-40 justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-base font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 md:mb-0"
            target="_blank"
            rel="noreferrer"
          >
            Купить в <img src={tgIcon} alt="TG" className="ml-2 w-4 h-4 sm:w-5 sm:h-5" />
          </a>
        </div>
      </div>
    </Container>
  );
  //
  // useEffect(() => {
  //   window.ym(93997310, "hit", "/playstation-discount", {
  //     params: {
  //       title: "Скидки PlayStation",
  //       referer: "https://trendy-eng-shop.ru/",
  //     },
  //   });
  //   window.scrollTo({
  //     top: 0,
  //     left: 0,
  //     behavior: "smooth",
  //   });
  // }, []);
  // const platform = [
  //   { value: "PS5", label: "PlayStation 5" },
  //   { value: "PS4", label: "PlayStation 4" },
  // ];
  // const region = [{ value: "PL", label: "Poland" }];
  // const button = (
  //   <div
  //     onClick={() => window.ym(93997310, "reachGoal", "tgClickPlayStation")}
  //     className="flex items-center justify-center"
  //   >
  //     <a
  //       href={"https://t.me/trendy_psn_bot?start=ref-001"}
  //       className=" mb-3 flex w-40 justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 md:mb-0"
  //       target="_blank"
  //       rel="noreferrer"
  //     >
  //       Купить в <img src={tgIcon} alt="TG" className=" ml-2" />
  //     </a>
  //   </div>
  // );
  // return <DiscountPage shop={platform} region={region} button={button} />;
}

export default PlayStationDiscount;
